import { apiClient } from '@src/services/http-common'
import { TechDebtMetric } from '@src/types/techdebt'
import { useQuery } from '@tanstack/react-query'

const TECH_DEBT_SCOPE = 'techDebt'

const keysFactory = {
  year: (year: number) => [TECH_DEBT_SCOPE, 'year', year] as const,
  last12Months: () => [TECH_DEBT_SCOPE, 'last12Months'] as const,
}

// Raw async function for tech debt metrics by year
export async function getTechDebtMetricsByYear(year: number): Promise<TechDebtMetric[]> {
  const response = await apiClient.get<TechDebtMetric[]>(`/TechDebt/Metrics/Year/${year}`)
  return response.data
}

// Raw async function for tech debt metrics for last 12 months
export async function getTechDebtMetricsLast12Months(): Promise<TechDebtMetric[]> {
  const response = await apiClient.get<TechDebtMetric[]>('/TechDebt/Metrics/Last12Months')
  return response.data
}

// React Query hook for tech debt metrics by year
export function useTechDebtMetricsByYear(year: number): [TechDebtMetric[] | undefined, boolean] {
  const { isFetching, data } = useQuery({
    queryFn: () => getTechDebtMetricsByYear(year),
    queryKey: keysFactory.year(year),
  })
  return [data, isFetching]
}

// React Query hook for tech debt metrics for last 12 months
export function useTechDebtMetricsLast12Months(): [TechDebtMetric[] | undefined, boolean] {
  const { isFetching, data } = useQuery({
    queryFn: () => getTechDebtMetricsLast12Months(),
    queryKey: keysFactory.last12Months(),
  })
  return [data, isFetching]
}
